import { LighthouseMark } from '../theme'
import { useAuth, isEntraConfigured } from '../auth'

function MicrosoftIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21">
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  )
}

// MSAL redirect login button — used when Entra env vars are configured
function MsalLoginButton() {
  const { login } = useAuth()

  return (
    <button
      onClick={() => login()}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 28px',
        borderRadius: 6,
        backgroundColor: 'var(--color-btn-primary)',
        color: 'var(--color-text-primary)',
        fontFamily: 'Inter, system-ui, sans-serif',
        fontSize: 14,
        fontWeight: 500,
        textDecoration: 'none',
        border: '1px solid var(--color-border)',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-btn-primary-hover)'
        e.currentTarget.style.boxShadow = 'var(--shadow-glow-accent)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-btn-primary)'
        e.currentTarget.style.boxShadow = 'none'
      }}
    >
      <MicrosoftIcon />
      Sign in with Microsoft
    </button>
  )
}

// SWA redirect login link — used in production on Azure Static Web Apps
function SwaLoginButton() {
  return (
    <a
      href="/.auth/login/aad?post_login_redirect_uri=/dashboard"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 28px',
        borderRadius: 6,
        backgroundColor: 'var(--color-btn-primary)',
        color: 'var(--color-text-primary)',
        fontFamily: 'Inter, system-ui, sans-serif',
        fontSize: 14,
        fontWeight: 500,
        textDecoration: 'none',
        border: '1px solid var(--color-border)',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-btn-primary-hover)'
        e.currentTarget.style.boxShadow = 'var(--shadow-glow-accent)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-btn-primary)'
        e.currentTarget.style.boxShadow = 'none'
      }}
    >
      <MicrosoftIcon />
      Sign in with Microsoft
    </a>
  )
}

export function LoginPage() {
  // Mode-independent by design: the hero illustration reads correctly against
  // both themes, so login needs no theme branching and the paper textures
  // (which fought the photograph) are gone.
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'var(--rail-bg)',
      backgroundImage: 'url(/brand/login-hero.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    }}>
      {/* Scrim: settles the photograph down so the panel edge stays legible */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'radial-gradient(ellipse at center, rgba(4,16,34,0.35) 0%, rgba(4,16,34,0.7) 100%)',
        zIndex: 1,
      }} />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 24,
        padding: '48px 48px 36px',
        borderRadius: 12,
        backgroundColor: 'var(--color-scrim-panel)',
        backdropFilter: 'blur(16px)',
        border: '1px solid var(--color-border)',
        boxShadow: 'var(--shadow-elevated)',
        maxWidth: 400,
        width: '100%',
        position: 'relative',
        zIndex: 2,
      }}>
        <div style={{ color: 'var(--color-accent-bronze)' }}>
          <LighthouseMark size={72} title="Lighthouse" />
        </div>

        <div style={{ textAlign: 'center' }}>
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 600,
            fontSize: 28,
            margin: 0,
            color: 'var(--color-text-primary)',
          }}>
            Lighthouse
          </h1>
          <p style={{
            fontFamily: 'var(--font-ui)',
            fontSize: 14,
            margin: '4px 0 0',
            color: 'var(--color-text-secondary)',
            letterSpacing: '0.5px',
          }}>
            Data Warehouse
          </p>
        </div>

        <p style={{
          fontFamily: 'var(--font-ui)',
          fontSize: 13,
          color: 'var(--color-text-disabled)',
          margin: 0,
        }}>
          Sign in with your organization account
        </p>

        {isEntraConfigured() ? <MsalLoginButton /> : <SwaLoginButton />}

        <p style={{
          fontFamily: 'var(--font-ui)',
          fontSize: 11,
          color: 'var(--color-text-disabled)',
          margin: '8px 0 0',
        }}>
          Powered by{' '}
          <span style={{ color: 'var(--color-accent-highlight)' }}>Terradome</span>
        </p>
      </div>
    </div>
  )
}
